import io from "socket.io-client";
const ENDPOINT = "https://realtime.celuwebdev.com/"
export const initSocket = () => {
    const socket = io(ENDPOINT);
    return socket
}